<template>
    <div class="basicData" v-wechat-title="$t('添加/编辑事业部')">
        <Title :title="$t('添加/编辑事业部')"/>
        <div class="form_box">
            <div class="form_box_line">
                <div class="form_box_line_item">
                    <div class="input_title"><span class="has_must">{{ $t('事业部') }}</span></div>
                    <div class="input_box">
                        <el-input  v-model.trim="parameters.name" clearable maxlength="15"></el-input>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('负责人') }}</span></div>
                    <div class="input_box">
                        <el-select  v-model.trim="parameters.managerId" clearable filterable :placeholder="$t('请选择')">
                            <el-option
                                    v-for="item in options"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('备件管理员') }}</span></div>
                    <div class="input_box">
                        <el-select  v-model.trim="parameters.partManagerId" clearable filterable :placeholder="$t('请选择')">
                            <el-option
                                    v-for="item in options"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <div class="form_box_line">
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('商务主管') }}</span></div>
                    <div class="input_box">
                        <el-select  v-model.trim="parameters.commercialManagerId" clearable filterable :placeholder="$t('请选择')">
                            <el-option
                                    v-for="item in options"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('商务专员') }}</span></div>
                    <div class="input_box">
                        <el-select  v-model.trim="parameters.commercialAttacheId" clearable filterable :placeholder="$t('请选择')">
                            <el-option
                                    v-for="item in options"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span class="has_must">{{ $t('经纬度') }}</span></div>
                    <div class="input_box">
                        <el-input  v-model.trim="parameters.lngLat" clearable maxlength="20"></el-input>
                    </div>
                </div>
            </div>
        </div>
        <GetBaiduPoint/>
        <div class="edit_btn_box">
            <button type="button" class="back_btn" @click="$router.go(-1)">{{ $t('返回') }}</button>
            <button type="button" class="save_btn" @click="save" v-permissions="26010103" v-noClick>{{ $t('保存') }}</button>
        </div>
    </div>
</template>

<script>
    import { longRG, latRG } from '../../plugins/regular'
    export default {
        data () {
            return {
                options: [],
                parameters: {
                    id: '',
                    level: 1,
                    name: '',
                    managerName: '',
                    partManagerName: '',
                    commercialManagerName: '',
                    commercialAttacheName: '',
                    longitude: '',
                    latitude: '',
                    managerId: '',
                    partManagerId: '',
                    commercialManagerId: '',
                    commercialAttacheId: '',
                    lngLat: ''
                }
            }
        },
        mounted () {
            this.initMounted()
        },
        methods: {
            initMounted () {
                if (this.$route.query.id) this.read()
                this.getUserList()
            },
            save () {
                if (!this.parameters.name || !this.parameters.lngLat) {
                    this.$message.info(this.$t('请填写必填信息'))
                    return false
                }
                this.parameters.longitude = this.parameters.lngLat.split(',')[0]
                this.parameters.latitude = this.parameters.lngLat.split(',')[1]
                if (!longRG(this.parameters.longitude)) {
                    this.$message.info(this.$t('经度整数部分为0-180,小数部分为0到6位'))
                    return false
                }
                if (!latRG(this.parameters.latitude)) {
                    this.$message.info(this.$t('纬度整数部分为0-90,小数部分为0到6位'))
                    return false
                }
                this.$store.dispatch('a:maintainEnterprise/save', this.parameters).then(
                    res => {
                        this.$message.success(this.$t('保存成功'));
                        this.$router.go(-1)
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                    }
                )
            },
            read () {
                this.$store.dispatch('a:maintainEnterprise/read', {id: this.$route.query.id}).then(
                    res => {
                        this.parameters = {
                            ...res,
                            name: res.enterpriseName,
                            id: this.$route.query.id,
                            lngLat: res.longitude + ',' + res.latitude
                        }
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                    }
                )
            },
            getUserList () {
                this.$store.dispatch('a:maintainEnterprise/getUserList', {
                    name: '',
                    limit: 10000
                }).then(
                    res => {
                        this.options = res
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                    }
                )
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
